// import { Injectable, inject, PLATFORM_ID } from '@angular/core';
// import { isPlatformBrowser } from '@angular/common';

// @Injectable({ providedIn: 'root' })
// export class Token {

//   private platformId = inject(PLATFORM_ID);

//   private isBrowser(): boolean {
//     return isPlatformBrowser(this.platformId);
//   }

//   get(): string | null {
//     if (this.isBrowser()) {
//       return localStorage.getItem('token');
//     }
//     return null;
//   }

//   set(token: string): void {
//     if (this.isBrowser()) {
//       localStorage.setItem('token', token);
//     }
//   }

//   clear(): void {
//     if (this.isBrowser()) {
//       localStorage.removeItem('token');
//     }
//   }

//   isLoggedIn(): boolean {
//     return !!this.get();
//   }
// }
// import { Injectable, inject, PLATFORM_ID } from '@angular/core';
// import { isPlatformBrowser } from '@angular/common';

// @Injectable({ providedIn: 'root' })
// export class Token {

//   private platformId = inject(PLATFORM_ID);

//   private isBrowser(): boolean {
//     return isPlatformBrowser(this.platformId);
//   }

//   get(): string | null {
//     if (this.isBrowser()) {
//       return sessionStorage.getItem('token');
//     }
//     return null;
//   }

//   set(token: string): void {
//     if (this.isBrowser()) {
//       sessionStorage.setItem('token', token);
//     }
//   }

//   clear(): void {
//     if (this.isBrowser()) {
//       sessionStorage.removeItem('token');
//     }
//   }

//   isLoggedIn(): boolean {
//     return !!this.get();
//   }
// }

//

import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class Token {
  private platformId = inject(PLATFORM_ID);

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  getToken(): string | null {
    if (!this.isBrowser()) return null;
    return sessionStorage.getItem('token');
  }

  setToken(token: string): void {
    if (!this.isBrowser()) return;
    sessionStorage.setItem('token', token);
  }

  clearToken(): void {
    if (!this.isBrowser()) return;
    sessionStorage.removeItem('token');
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }
}
